import { getData } from 'util/Api';
import { haveDateLoaded } from 'constants/operations';
import API from 'constants/api';
import { call, put, select, all, takeLatest } from 'redux-saga/effects';
import { authProfile } from 'redux/auth/selectors';
import { actions } from './slice';
import { selectPackagesWithoutZone } from './selectors';

const URL = API.packages.withoutZone;

function* fetchSaga() {
  try {
    const {
      pageable: { pageNumber, pageSize },
      search,
      status,
      type,
      date,
    } = yield select(selectPackagesWithoutZone);
    const { marketplace } = yield select(authProfile);
    const searchParams = new URLSearchParams({
      page: pageNumber,
      size: pageSize,
      desc: true,
      packageType: type,
      marketplaceId: marketplace.id,
      search,
      status,
      from: date.from,
      to: date.to,
    });
    const packages = yield call(getData, `${URL}?${searchParams.toString()}`);
    const items = packages.content;
    const total = packages.totalElements;
    yield put({
      type: actions.success.type,
      payload: {
        items,
        total,
      },
    });
  } catch (error) {
    yield put({ type: actions.failure.type });
  }
}

function* updateBasefilters() {
  const { status, date } = yield select(selectPackagesWithoutZone);
  if (status === null || !haveDateLoaded(date)) {
    return;
  }
  yield put({
    type: actions.fetch.type,
  });
}

function* addPacketSagas({ payload }) {
  const { items } = yield select(selectPackagesWithoutZone);
  const index = items.findIndex((packet) => packet.id === payload.id);
  if (index !== -1 && items[index].status === payload.status) {
    return;
  }
  yield call(updateBasefilters);
}

export default function* rootSaga() {
  yield all([
    takeLatest(
      [
        actions.updatePagination,
        actions.updateSearch,
        actions.updatePackageType,
        actions.updateStatus,
        actions.refreshPage,
        actions.resetFilters,
        actions.updateDate,
      ],
      updateBasefilters,
    ),
    takeLatest(actions.updatePacket, addPacketSagas),
    takeLatest(actions.fetch, fetchSaga),
  ]);
}
